"use client";

import { useEffect } from "react";
import { Locale } from "@/i18n/routing";

// The root layout (and its <html lang>) is preserved across client-side locale switches.
const DocumentLanguage = ({ locale }: { locale: Locale }) => {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
};

export default DocumentLanguage;